import { REDUX_SLICE } from '../constants';
import { claimGalaApi } from '../services/claimGala.service';
import { otcApi } from '../services/otc.service';
import { priceApi } from '../services/price.service';
import { projectApi } from '../services/project.service';
import { redeemApi } from '../services/redeem.service';
import { referralApi } from '../services/referral.service';
import { rewardApi } from '../services/reward.service';
import { appSlice } from '../slices/app.slice';
import { projectSlice } from '../slices/project.slice';

export const reducer = {
  [REDUX_SLICE.APP]: appSlice.reducer,
  [REDUX_SLICE.PROJECT]: projectSlice.reducer,
  [REDUX_SLICE.CLAIM_GALA_API]: claimGalaApi.reducer,
  [REDUX_SLICE.PRICE_API]: priceApi.reducer,
  [REDUX_SLICE.PROJECT_API]: projectApi.reducer,
  [REDUX_SLICE.REDEEM_API]: redeemApi.reducer,
  [REDUX_SLICE.REFERRAL_API]: referralApi.reducer,
  [REDUX_SLICE.REWARD_API]: rewardApi.reducer,
  [REDUX_SLICE.OTC_API]: otcApi.reducer,
};
